<script>
import { mapActions } from "vuex";

import LoadingSpinner from "../../components/LoadingSpinner.vue";
import SwitchButton from "../../components/SwitchButton.vue";

import ReportHeaderComponent from "./reportHeaderComponent.vue";
import Card from "../../components/Card.vue";

export default {
    components: {
        LoadingSpinner,
        SwitchButton,
        ReportHeaderComponent,
        Card
    },

    props: {
        surveys: {
            type: Object,
            required: true
        },

        su2SurveyId: {
            type: Number,
            required: true
        },

        initialLanguage: {
            type: String,
            default: ""
        },

        selectedReportLanguages: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            report_header_groups: [
                {
                    text: '',
                    color: '#f0723f',
                    is_created: false,
                    headers: [],
                },
                {
                    text: this.$t('section_generation.report_headers.groups.overview'),
                    color: '#da3f92',
                    is_created: false,
                    headers: [],
                },
                {
                    text: this.$t('section_generation.report_headers.groups.our_sustainability_strategy'),
                    color: '#0da3d1',
                    is_created: false,
                    headers: [],
                },
                {
                    text: this.$t('section_generation.report_headers.groups.corporate_governance'),
                    color: '#004578',
                    is_created: false,
                    headers: [],
                },
                {
                    text: this.$t('section_generation.report_headers.groups.product_quality_tech'),
                    color: '#c57a22',
                    is_created: false,
                    headers: [],
                },
                {
                    text: this.$t('section_generation.report_headers.groups.environment'),
                    color: '#7ebb58',
                    is_created: false,
                    headers: [],
                },
                {
                    text: this.$t('section_generation.report_headers.groups.social_responsibility'),
                    color: '#df0f2d',
                    is_created: false,
                    headers: [],
                },
            ],

            selected_report_header: null,

            reportCreatingStep: 1,

            reportToCreate: {
                selectedSu1: null,
                selectedSu2: null,
                name: null,
                description: null,
                language: null,
            },

            createReportInProgress: false,
            close_create_report_timeout: null,
        }
    },

	beforeDestroy() {
		if (this.close_create_report_timeout != null) {
			clearTimeout(this.close_create_report_timeout);
		}
	},

    mounted() {
        this._getReportHeaders();
    },

    methods: {
        ...mapActions('reports', [
            'getReportHeaders',
            'createdSectionHeaders',
            'createMyReports',
        ]),

        _getReportHeaders() {
            const params = {
                report_type: 'sustainability_report',
                sector_id: Number(localStorage.getItem('sector_id')),
                is_deleted: false
            };

            this.createdSectionHeaders({ company_id: this.$user.company_id, report_type: "sustainability_report" })
                .then(r => {
                    const created_report_headers = r.data;

                    this.getReportHeaders(params)
                        .then(res => {
                            for (let i = 0; i < res.data.length; i++) {
                                const header = res.data[i];
                                const report_header_order = String(header.report_header_order);

                                if (report_header_order.length === 1) {
                                    this.report_header_groups[0].headers.push(header);
                                } else {
                                    const corrected_index = Number(report_header_order[0]);

                                    if (this.report_header_groups[corrected_index]) {
                                        this.report_header_groups[corrected_index].headers.push(header);
                                    }
                                }

                                header.is_created = created_report_headers.includes(header.report_header_name);
                            }
                        })
                        .catch(({ response }) => {
                            console.error(response.data.messageName);
                        })
                        .finally(() => {
                            const id = this.$route.query['report-header-id'];
                            if (id) {
                                const el = document.getElementById(`report_header_${id}`);
                                if (el) {
                                    el.click();
                                }
                            }
                        })
                })
        },

        async openReportHeader(header) {
            if (!header.is_sector_match) return;

            await this.setReportHeader(header);
            await this.$refs.sectionPopup.openPopup();
        },

        async setReportHeader(header) {
            this.selected_report_header = header;
        },

        handleSectionOnHide() {
            this.$router.replace({'query': null});
        },

        //#region Report Creating

        createSustReport() {
            if (this.createReportInProgress == true) {
                return;
            }

            const report_lang = !this.selectedReportLanguages || this.selectedReportLanguages.length === 0 ? 'en' : (
                this.selectedReportLanguages.length === 1 ?
                    this.selectedReportLanguages[0] :
                    this.reportToCreate.language
            );

            const params = {
                user_id: this.$user.user_id,
                my_report_name: this.reportToCreate.name,
                my_report_description: this.reportToCreate.description,
                report_type: `sustainability_report`,
                company_id: this.$user.company_id,
                su1_survey_id: this.reportToCreate.name.selectedSu1,
                su2_survey_id: this.reportToCreate.name.selectedSu2,
                report_language: report_lang,

            };

            this.createReportInProgress = true;

            this.createMyReports(params)
                .then((res) => {
                    this.$addQueuedJob({
						job_id: res.data.job_id,
						options: {
							path: '/reports',
							query: null,
							type: 'report_creation'
						},
						result: null,
					});

					this.close_create_report_timeout = setTimeout(() => {
						this.$refs.sustReportCreatePopup.startHideProcess();
					}, 30000);
                })
                .catch(({ response }) => {
                    this.$notify.open('error', response.data.messageName);
                })
                .finally(() => {
                    this.resetReportPopup();
                })
        },

        async openReportPopup() {
            if (this.surveys.su1.length > 0) {
                await this.setSurvey(1, this.surveys.su1[0]);
            }

            if (this.surveys.su2.length > 0) {
                await this.setSurvey(2, this.surveys.su2[0]);
            }

            this.reportToCreate.language = !this.selectedReportLanguages || this.selectedReportLanguages.length === 0 ? 'en' : this.selectedReportLanguages[0];

            this.$refs.sustReportCreatePopup.openPopup();
        },

        resetReportPopup() {
            this.reportCreatingStep = 1;
            this.reportToCreate = {
                selectedSu1: null,
                selectedSu2: null,
                name: null,
                description: null,
                language: null,
            };
        },

        async setSurvey(type, survey) {
            this.reportToCreate[`selectedSu${type}`] = survey;
        }

        //#endregion Report Creating
    }
}
</script>

<template>
    <Card class="flex-all-centered-col report-sections-main">
        <div class="contents-text">
            {{ $t('generateSections.contents') }}
        </div>
        
        <div class="flex-all-centered-col report-sections">
            <div v-for="(group, idx) in report_header_groups" :key="idx"
                class="report-header-group"
                :style="{
                    'color': group.color
                }"
            >
                <div class="group-name">
                    {{ group.text }}
                </div>
    
                <div v-for="header in group.headers" :key="header.report_header_id"
                    :id="`report_header_${header.report_header_id}`"
                    tabindex="0"
                    class="report-header"
                    :class="{
                        'non-sector-match-header': !header.is_sector_match
                    }"
                    @click="openReportHeader(header)"
                >
                    <i v-if="header.is_created" class="fa-solid fa-check" style="margin-right: .5em;"></i>
                    <span>{{ header.report_header_name }}</span>
                </div>
            </div>
        </div>

        <button class="sust-btn sust-btn-green" style="align-self: flex-end; justify-self: flex-end; pointer-events: all !important;"
            @click="openReportPopup()"
            :disabled="createReportInProgress"
            v-sust-tooltip="{
                text: 'Your report is currently being prepared...',
                condition: createReportInProgress === true
            }"
        >
            <loading-spinner v-if="createReportInProgress" color="white" />
            <span v-else>{{ $t('generateSections.buttons.sust') }}</span>
        </button>

        <sust-popup ref="sectionPopup"
            size="lg"
            title=""
            :footer="false"
            @onHide="handleSectionOnHide()"
        >
            <report-header-component 
                :report_header="selected_report_header"
                :report_languages="selectedReportLanguages"
                :selected_su2_survey_id="su2SurveyId"
                @close_popup="() => $refs.sectionPopup.startHideProcess()"
            />   
        </sust-popup>

        <sust-popup ref="sustReportCreatePopup" 
            size="lg"
            :title="$t('generateSections.tabs.sustTitle')" 
            :footer="false"
            @onHide="resetReportPopup()" 
        >
            <div v-if="createReportInProgress" class="flex-all-centered-col">
				<div>
					{{ $t('myReports.createModal.inProgress') }}
				</div>
				<loading-spinner style="font-size: 2em; padding: .5em;" color="var(--sustainfinity-green)" />
			</div>

            <div v-else-if="reportCreatingStep == 1"
                class="flex-all-centered-col"
            >
                <div class="flex-all-centered-row">
                    <div class="survey-selector flex-all-centered-col">
                        <label for="input">
                            SDG Alignment Survey
                        </label>
                        <select name="input" v-model="reportToCreate.selectedSu1">
                            <option v-for="survey in surveys.su1" 
                                :key="survey.su1_survey_id"
                                :value="survey"
                            >
                                {{ survey.su1_survey_name }}
                            </option>
                        </select>
                    </div>

                    <div class="survey-selector flex-all-centered-col">
                        <label for="input">
                            Materiality Analysis Survey
                        </label>
                        <select name="input" v-model="reportToCreate.selectedSu2">
                            <option v-for="survey in surveys.su2" 
                                :key="survey.su2_survey_id"
                                :value="survey"
                            >
                                {{ survey.su2_survey_name }}
                            </option>
                        </select>
                    </div>
                </div>

                <button class="icon-button report-icon-button" style="align-self: flex-end; font-size: 1.5em; margin-top: .5em;"
                    @click="() => reportCreatingStep++"
                    :disabled="reportToCreate.selectedSu1 === null || reportToCreate.selectedSu1 === null"
                >
                    <i class="fa-solid fa-circle-right"></i>
                </button>
            </div>

            <div class="flex-all-centered-col" style="width: 100%; position: relative; padding-bottom: 50px;" v-else-if="reportCreatingStep == 2">
                <div class="flex-all-centered-row">
                    <div class="survey-selector flex-all-centered-col">
                        <label for="input">
                            {{ $t('myReports.createModal.reportName') }}
                        </label>
                        <input type="text" v-model="reportToCreate.name" maxlength="100">
                    </div>

                    <div class="survey-selector flex-all-centered-col">
                        <label for="reportLangSelect">
                            {{ $t('myReports.createModal.reportLanguage') }}
                        </label>
                        <select id="reportLangSelect" v-model="reportToCreate.language"
                            v-if="selectedReportLanguages && selectedReportLanguages.length > 1"
                        >
                            <option v-for="lang in selectedReportLanguages" :key="lang" :value="lang">
                                {{ lang.toUpperCase() }}
                            </option>
                        </select>
                        <input v-else disabled type="text" :value="reportToCreate.language.toUpperCase()">
                    </div>
                </div>

                <div class="survey-selector flex-all-centered-col">
                    <label for="input">
                        {{ $t('myReports.createModal.reportDescription') }}
                    </label>
                    <textarea 
                        style="width: 100%;"
                        v-model="reportToCreate.description" 
                        maxlength="2000"
                        rows="3"
                    ></textarea>
                </div>

                <div class="flex-all-centered-row" style="justify-content: space-between; margin-top: .5em; font-size: 1.5em;">
                    <button class="icon-button report-icon-button" style="margin: 0 !important;"
                        @click="() => reportCreatingStep--"
                    >
                        <i class="fa-solid fa-circle-left"></i>
                    </button>
                    <button class="icon-button report-icon-button" style="margin: 0 !important;"
                        @click="createSustReport()"
                        :disabled="!reportToCreate.name || !reportToCreate.description || !reportToCreate.language"
                    >
                        <i class="fa-solid fa-floppy-disk"></i>
                    </button>
                </div>
            </div>
        </sust-popup>
    </Card>
</template>

<style lang="scss" scoped>
    .report-sections-main {
        max-height: 80vh !important;
        padding: 2em;
    }

    .report-sections {
        justify-content: stretch;
        align-items: stretch;
        flex-wrap: wrap;
        align-content: stretch;
        max-height: 70vh !important;
    }

    .contents-text {
        color: var(--sustainfinity-navy); 
        font-size: 1.4em; 
        font-weight: bold;
        border-bottom: .15em solid var(--sustainfinity-navy);
        max-width: fit-content;
    }

    .report-header-group {
        width: 50% !important;

        > .group-name {
            font-size: 1.1em;
            font-weight: bold;
            padding: .5em 0;
            text-transform: uppercase;
        }

        > .report-header {
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
            &:focus {
                border: 0;
                outline: 0;
                text-decoration: underline;
            }
        }

        > .non-sector-match-header {
            pointer-events: none !important;
            color: gray !important;
        }
    }

    .survey-selector {
        max-width: 95%;
        flex: 1;

        >label {
            margin: 0;
            padding: 0;
            font-weight: bold;
            font-size: 1.25em;
            text-align: center;
            width: 100%;
        }

        >select,
        input,
        textarea {
            width: 90%;
            border-radius: .25em;
            padding: .35em;
            text-align: center;

            transition: outline 150ms;

            border: 0 !important;
            outline: thin solid darkgray !important;

            &:focus {
                outline: .1em solid black !important;
            }
        }
    }

    .report-icon-button {
        background-color: transparent !important;
        color: var(--sustainfinity-navy);

        transition: color 250ms;
        &:hover {
            color: var(--sustainfinity-navy--hover);
        }

        &:disabled {
            background-color: transparent !important;
            color: gray !important;
        }
    }
</style>